import script from "./TiktokGamblingWhiteListForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokGamblingWhiteListForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__